import { BellIcon } from '@eventbrite/marmalade';
import { useEffect, useState } from 'react';
import { hasUnseenContentCards, getContentCards } from '@eventbrite/braze';
import React from 'react';
import { useBrazeNotificationRedDot, getUserId } from '@eventbrite/braze';

const USER_TYPE_CREATOR = 'creator';

export default function GlobalHeaderNotificationIcon({ userMenuInfo }) {
    const [shouldShow, setShouldShow] = useState(false);

    useEffect(() => {
        if (typeof window === 'undefined') return;

        const isCreator = userMenuInfo?.userType === USER_TYPE_CREATOR;
        const isFeatureEnabled =
            window?.__SERVER_DATA__?.featureFlags
                ?.enableBrazeNotificationCentre;

        setShouldShow(isCreator && isFeatureEnabled && hasValidUserAndOrgId());
    }, [userMenuInfo]);

    if (!shouldShow) return null;
    return <NotificationIcon />;
}

export const hasValidUserAndOrgId = () => {
    try {
        return Boolean(getUserId());
    } catch (err) {
        console.error('[Braze] Failed to resolve user/org identity', err);
        return false;
    }
};

const NotificationIcon = () => {
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const hasNotification = useBrazeNotificationRedDot(isDrawerOpen);

    const handleShowContentCards = () => {
        getContentCards();
        setIsDrawerOpen(true);
    };

    return (
        <div
            data-testid="notification-icon"
            className={`eds-notification-icon ${
                hasNotification ? 'eds-has-notification' : ''
            }`}
            onClick={handleShowContentCards}
        >
            <BellIcon data-testid="notification-bell-icon" />
            {hasNotification && (
                <span
                    className="eds-red-dot"
                    data-testid="notification-red-dot"
                />
            )}
        </div>
    );
};
